import { Tooltip } from './tooltip';

export * from './tooltip';

export default Tooltip;
